export enum STOCK_ITEM_DETAILS_DOMAIN {
  STOCK_ITEM = 'stockItem',
  BY_SPARE_PART_REQUEST_LINE_ID = 'bySparePartRequestLineId',
}

export const STOCK_ITEM_DETAILS_DOMAIN_KEY = 'stockItemDetails';
